import { ButtonGroup } from "@tql/ui-components-react/kendo/buttons";
import { Button } from "@tql/ui-components-react/tql/buttons";

import type { Stop } from "~/features/ftl/shared/ftl-stop";

import * as styles from "./stop-type-selector.module.css";

export type StopTypeSelectorProps = {
	readonly stop: Stop;
	readonly stopIndex: number;
	readonly deletable: boolean;
	readonly valid: boolean;
	readonly onDeleteStop: (index: number) => void;
	readonly onChange: (params: { value: string }) => void;
};

export function StopTypeSelector(props: StopTypeSelectorProps) {
	const getPickupVariant = () => {
		if (!props.valid) return "dangerSecondary";
		return props.stop?.stopType === "Pickup" ? "primary" : "secondary";
	};

	const getDeliveryVariant = () => {
		if (!props.valid) return "dangerSecondary";
		return props.stop?.stopType === "Delivery" ? "primary" : "secondary";
	};

	const variant = {
		pickup: getPickupVariant(),
		delivery: getDeliveryVariant(),
	} as const;

	return (
		<div
			className={styles.stopType}
			data-testid={`stop-type-selector-${props.stopIndex}`}
		>
			<ButtonGroup>
				<Button
					data-testid={`stop-type-${props.stopIndex}-pickup`}
					formAction={"none"}
					onClick={() => props.onChange({ value: "Pickup" })}
					variant={variant.pickup}
				>
					Pick
				</Button>
				<Button
					data-testid={`stop-type-${props.stopIndex}-delivery`}
					formAction={"none"}
					onClick={() => props.onChange({ value: "Delivery" })}
					variant={variant.delivery}
				>
					Drop
				</Button>
			</ButtonGroup>
		</div>
	);
}
